<div class="wrapper" *transloco="let t; read: 'oldStudentModal'">


    <div class="action-wrapper" [ngClass]="{'width-100': withoutCertificates}">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5812_10255)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M32.0489 9.99805C31.4781 9.99805 30.9129 10.1121 30.3866 10.3336C29.8638 10.5535 29.3901 10.875 28.9926 11.2794L11.1705 28.9871C10.9309 29.2254 10.7833 29.5406 10.7542 29.8771L10.0113 38.4486C9.97492 38.8688 10.1261 39.2837 10.4244 39.5823C10.7227 39.8806 11.1376 40.0317 11.5579 39.9951L20.1293 39.2523C20.4659 39.2231 20.7813 39.0757 21.0194 38.836L38.7263 21.0148L38.7306 21.0106C39.1303 20.613 39.4475 20.1406 39.6643 19.6202C39.8821 19.0979 39.9941 18.5378 39.9941 17.972C39.9941 17.4062 39.8821 16.846 39.6643 16.3238C39.4478 15.8036 39.1303 15.3312 38.7309 14.9338L35.1132 11.2875L35.1089 11.2834C34.7106 10.8771 34.2355 10.5542 33.7112 10.3336C33.1849 10.1121 32.6198 9.99805 32.0489 9.99805Z"
                      fill="#83B25F"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12.8033 1.84935C12.2383 -0.627521 8.70471 -0.612075 8.16145 1.86963L8.13891 1.97299L8.094 2.17741C7.41974 5.19667 4.99171 7.51359 1.94169 8.04419C-0.639265 8.49322 -0.639245 12.1983 1.94169 12.6473C5.00237 13.1798 7.43668 15.511 8.10102 18.5458L8.16145 18.8218C8.70471 21.3036 12.2383 21.319 12.8033 18.8421L12.8767 18.5204C13.5662 15.4971 16.0035 13.1834 19.0586 12.6518C21.6446 12.2019 21.6446 8.48953 19.0586 8.03965C16.0197 7.51096 13.5921 5.21887 12.8878 2.21917C12.8685 2.13704 12.8506 2.05795 12.8313 1.97291L12.8033 1.84935Z"
                      fill="#3F403F"/>
            </g>
            <defs>
                <clipPath id="clip0_5812_10255">
                    <rect width="40" height="40" fill="white"/>
                </clipPath>
            </defs>
        </svg>


        <div class="title">
            {{ doTest ? t('noTest') : t('haveTest') }}
        </div>

        <div class="btn-wrapper">

            <button type="button" class="btn dark-btn" *ngIf="doTest" (click)="getEnglishLevelExamUrl()">
                {{ t('doTest') }}

            </button>

            <button type="button" class="btn dark-btn" *ngIf="!doTest" (click)="openRequestModal('continueStudy')">
                {{ t('request') }}

            </button>
        </div>
    </div>


    <div class="certificate" [routerLink]="['/certificates']" *ngIf="!withoutCertificates">

        <div class="img-wrapper">
            <img src="assets/images/student/certificate.svg" alt="My certificates">

            <div class="next">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#3F403F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.67461 6.95437C9.88428 6.77465 10.1999 6.79893 10.3796 7.0086L14.3796 11.6753C14.5401 11.8625 14.5401 12.1388 14.3796 12.3261L10.3796 16.9927C10.1999 17.2024 9.88428 17.2267 9.67461 17.047C9.46495 16.8672 9.44067 16.5516 9.62038 16.3419L13.3415 12.0007L9.62038 7.65939C9.44067 7.44973 9.46495 7.13408 9.67461 6.95437Z"
                          fill="white"/>
                </svg>

            </div>
        </div>

        <div class="title">
            {{ t('certificates') }}

        </div>


    </div>
</div>
